<div class="scanner-component">
  Scan een barcode om te beginnen
  <button mat-raised-button class="open-cam-button" color="primary" (click)="openCameraScanner()">Scannen met camera</button>
</div>
